import { render, staticRenderFns } from "./dg-head.vue?vue&type=template&id=6c6fe28c&scoped=true"
import script from "./dg-head.vue?vue&type=script&lang=js"
export * from "./dg-head.vue?vue&type=script&lang=js"
import style1 from "./dg-head.vue?vue&type=style&index=1&id=6c6fe28c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6fe28c",
  null
  
)

export default component.exports